import { render, staticRenderFns } from "./ChatFrame.vue?vue&type=template&id=184032a2&"
import script from "./ChatFrame.vue?vue&type=script&lang=ts&"
export * from "./ChatFrame.vue?vue&type=script&lang=ts&"
import style0 from "./ChatFrame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports